var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper",class:_vm.classPrefix && (_vm.classPrefix + "-wrapper")},[_c('div',{staticClass:"content",class:_vm.classPrefix && (_vm.classPrefix + "-content")},[_vm._t("default")],2),_c('Nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }